const componentStyles = (theme) => ({
    header: {
        background: theme.palette.dark.main,
    },
});

export default componentStyles;
